<template>
  <a-drawer
    width="70%"
    :visible="open"
    :body-style="{ paddingBottom: '80px' }"
    @cancel="cancel"
    @close="cancel"
  >
    <div slot="title">
      {{ formType === 1 ? $t('通用.按钮.新增') : $t('通用.按钮.修改') }}
    </div>

    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-divider orientation="left">{{ $t('空间.基础信息') }}</a-divider>

      <a-form-model-item :label="$t('空间.空间名称')" prop="spaceName">
        <a-input v-model="form.spaceName" :maxLength="100" />
      </a-form-model-item>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label="$t('空间.封面图')" prop="coverImage">
            <OssUploadSingle v-model="form.coverImage" type="img" :maxSize="200"></OssUploadSingle>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('空间.空间主图')" prop="mainImage">
            <OssUploadSingle v-model="form.mainImage" type="img" :maxSize="200"></OssUploadSingle>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item :label="$t('空间.是否免费')" prop="isFree">
            <a-radio-group v-model="form.isFree" button-style="solid">
              <a-radio-button :value="1">{{ $t('空间.免费') }}</a-radio-button>
              <a-radio-button :value="0">{{ $t('空间.收费') }}</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('空间.购买价钱')" prop="price" v-if="form.isFree === 0">
            <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('空间.状态')" prop="status">
            <a-radio-group v-model="form.status" button-style="solid">
              <a-radio-button :value="1">{{ $t('空间.启用') }}</a-radio-button>
              <a-radio-button :value="0">{{ $t('空间.禁用') }}</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item :label="$t('空间.排序')" prop="sort">
            <a-input-number v-model="form.sort" :min="0" style="width: 100%" />
          </a-form-model-item>
        </a-col>
      </a-row>

<!--      <a-form-model-item :label="$t('空间.空间描述')" prop="description">-->
<!--        <a-textarea v-model="form.description" :rows="3" :maxLength="500" show-count />-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item :label="$t('空间.备注')" prop="remark">-->
<!--        <a-textarea v-model="form.remark" :rows="2" :maxLength="255" show-count />-->
<!--      </a-form-model-item>-->

      <a-divider orientation="left">{{ $t('空间.空间门管理') }}</a-divider>

      <div class="door-list">
        <a-row :gutter="16" v-for="(door, index) in form.doorList" :key="index">
          <a-col :span="8">
            <a-form-model-item :label="door.doorTypeName" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <div class="door-item">
                <img v-if="door.doorImage" :src="door.doorImage" class="door-image" />
                <span v-else class="door-placeholder">{{ $t('空间.请上传') }}</span>
                <div class="door-upload">
                  <OssUploadSingle
                    v-model="door.doorImage"
                    type="img"
                    :maxSize="200"
                  ></OssUploadSingle>
                </div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{$t('通用.按钮.保存')}}</a-button>
          <a-button @click="cancel">{{$t('通用.按钮.取消')}}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpace, addSpace, updateSpace, getDoorTypes } from '@/api/space/space'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      formType: 1,
      submitLoading: false,
      open: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        id: null,
        spaceName: null,
        coverImage: null,
        mainImage: null,
        isFree: 1,
        price: 0,
        description: null,
        status: 1,
        sort: 0,
        remark: null,
        doorList: []
      },
      rules: {
        spaceName: [{ required: true, message: this.$t('空间.空间名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        coverImage: [{ required: true, message: this.$t('空间.封面图') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        mainImage: [{ required: true, message: this.$t('空间.空间主图') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        isFree: [{ required: true, message: this.$t('空间.是否免费') + this.$t('通用.文本.不能为空'), trigger: 'change' }]
      },
      doorTypes: []
    }
  },
  mounted() {
    this.loadDoorTypes()
  },
  methods: {
    loadDoorTypes() {
      getDoorTypes().then(response => {
        this.doorTypes = response.data || []
        // 初始化门列表
        this.initDoorList()
      })
    },
    initDoorList() {
      this.form.doorList = this.doorTypes.map(door => ({
        id: null,
        doorType: door.doorType,
        doorTypeName: door.doorTypeName,
        doorImage: null,
        status: 1
      }))
    },
    handleAdd() {
      this.formType = 1
      this.resetForm()
      this.open = true
      this.$nextTick(() => {
        this.initDoorList()
      })
    },
    handleUpdate(record) {
      this.formType = 2
      this.open = true
      this.$nextTick(() => {
        // 先加载门类型，再加载详情
        getDoorTypes().then(doorTypesResponse => {
          this.doorTypes = doorTypesResponse.data || []
          // 初始化门列表
          this.form.doorList = this.doorTypes.map(door => ({
            id: null,
            doorType: door.doorType,
            doorTypeName: door.doorTypeName,
            doorImage: null,
            status: 1
          }))

          // 再获取空间详情
          getSpace({ id: record.id }).then(response => {
            const data = response.data
            this.form.id = data.id
            this.form.spaceName = data.spaceName
            this.form.coverImage = data.coverImage
            this.form.mainImage = data.mainImage
            this.form.isFree = data.isFree
            this.form.price = data.price
            this.form.description = data.description
            this.form.status = data.status
            this.form.sort = data.sort
            this.form.remark = data.remark
            // 填充门数据
            if (data.doorList && data.doorList.length > 0) {
              data.doorList.forEach(door => {
                const existDoor = this.form.doorList.find(d => d.doorType === door.doorType)
                if (existDoor) {
                  existDoor.id = door.id
                  existDoor.doorImage = door.doorImage
                  existDoor.status = door.status
                }
              })
            }
          })
        })
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 处理门列表：过滤掉没有图片的门
          const doorList = this.form.doorList.filter(door => door.doorImage)
          const submitData = { ...this.form, doorList }

          if (this.form.id) {
            updateSpace(submitData).then(() => {
              this.$message.success(this.$t('通用.文本.修改成功'))
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpace(submitData).then(() => {
              this.$message.success(this.$t('通用.文本.新增成功'))
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        }
      })
    },
    cancel() {
      this.open = false
    },
    resetForm() {
      this.form = {
        id: null,
        spaceName: null,
        coverImage: null,
        mainImage: null,
        isFree: 1,
        price: 0,
        description: null,
        status: 1,
        sort: 0,
        remark: null,
        doorList: []
      }
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.door-list {
  padding: 10px 0;
}
.door-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.door-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 8px;
}
.door-placeholder {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 8px;
  color: #999;
}
.door-upload {
  margin-top: 4px;
}
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-top: 1px solid #e8e8e8;
}
</style>
